import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { CreateOnDemandScanComponent } from './create-on-demand-scan.component';

@NgModule({
    declarations: [CreateOnDemandScanComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class CreateOnDemandScanModule { }
